import { useApolloClient } from '@apollo/client/react';
import { Button } from '@chakra-ui/react';
import { useState } from 'react';

import { toaster } from '#/components/ui/toaster';
import { useAppConfig } from '#/providers/app-config-provider';
import { getApolloPersistStorageKey } from '#/utils/apollo-persist-key';

/** Clears persisted GraphQL cache for this browser and refetches active queries. */
export function ClearClientCacheButton() {
  const client = useApolloClient();
  const { config } = useAppConfig();
  const [loading, setLoading] = useState(false);

  return (
    <Button
      size="sm"
      variant="outline"
      colorScheme="gray"
      loading={loading}
      onClick={() => {
        setLoading(true);
        void (async () => {
          try {
            try {
              if (typeof window !== 'undefined') {
                window.localStorage.removeItem(
                  getApolloPersistStorageKey(config.graphqlUrl),
                );
              }
            } catch {
              // ignore storage errors
            }
            await client.resetStore();
            toaster.create({
              title: 'Cache cleared',
              description: 'Local cached data was cleared and refreshed.',
              type: 'success',
              duration: 3000,
              closable: true,
            });
          } catch (err) {
            toaster.create({
              title: 'Error',
              description:
                err instanceof Error
                  ? err.message
                  : 'Could not clear the cache.',
              type: 'error',
            });
          } finally {
            setLoading(false);
          }
        })();
      }}
    >
      Clear cache
    </Button>
  );
}
